export default __webpack_public_path__ + "static/media/three_of_pentacles.db9be11c.png";